module.exports = __webpack_public_path__ + "static/media/31JFA6.c02f06a9.jpg";